// Configs do CRUD genérico (components/Crud.jsx) para as entidades simples.
const money = (v) => (v == null || v === '' ? '—' : `R$ ${Number(v).toFixed(2)}`)
const pct = (v) => (v == null || v === '' ? '—' : `${Number(v)}%`)
const bool = (v) => (v ? 'Sim' : 'Não')

export const clientes = {
  title: 'Clientes', endpoint: '/clientes',
  columns: [
    { key: 'nome', label: 'Nome' }, { key: 'cpf_cnpj', label: 'CPF/CNPJ' },
    { key: 'email', label: 'Email' }, { key: 'telefone', label: 'Telefone' },
    { key: 'cidade', label: 'Cidade' }, { key: 'licenciado_nome', label: 'Licenciado' },
  ],
  fields: [
    { key: 'cpf_cnpj', label: 'CPF/CNPJ (busca cadastro existente)', type: 'cpf' },
    { key: 'nome', label: 'Nome completo' },
    { key: 'email', label: 'E-mail' }, { key: 'telefone', label: 'Telefone' },
    { key: 'whatsapp', label: 'WhatsApp' }, { key: 'data_nascimento', label: 'Data de nascimento', type: 'date' },
    { key: 'cep', label: 'CEP (preenche o endereço)', type: 'cep' },
    { key: 'endereco', label: 'Endereço (logradouro)' }, { key: 'numero', label: 'Número' },
    { key: 'complemento', label: 'Complemento' }, { key: 'bairro', label: 'Bairro' },
    { key: 'cidade', label: 'Cidade' }, { key: 'estado', label: 'UF' },
    // Vinculação comercial (obrigatória: licenciado responsável)
    { key: 'licenciado_id', label: 'Licenciado Responsável (obrigatório)', type: 'select', adminOnly: true,
      optionsUrl: '/licenciados?limit=200', optionLabel: 'nome', optionValue: 'id', optionsEmpty: '— selecione —' },
    { key: 'parceiro_id', label: 'Parceiro/Fornecedor', type: 'select',
      optionsUrl: '/parceiros?limit=200', optionLabel: 'nome', optionValue: 'id', optionsEmpty: '— nenhum —' },
    { key: 'oferta_id', label: 'Produto/Serviço contratado', type: 'select',
      optionsUrl: '/ofertas?limit=200', optionLabel: 'nome', optionValue: 'id', optionsEmpty: '— nenhum —' },
    { key: 'numero_instalacao', label: 'Número da Instalação (quando aplicável)' },
    { key: 'codigo_externo_parceiro', label: 'Código Externo do Parceiro' },
  ],
}

export const licenciados = {
  title: 'Licenciados', endpoint: '/licenciados',
  columns: [
    { key: 'nome', label: 'Nome' }, { key: 'codigo_indicacao', label: 'Código' },
    { key: 'cargo', label: 'Cargo' }, { key: 'cidade', label: 'Cidade' },
    { key: 'pv', label: 'PV' }, { key: 'total_indicados', label: 'Indicados' },
    { key: 'ativo', label: 'Ativo', render: (r) => bool(r.ativo) },
  ],
  fields: [
    { key: 'cpf_cnpj', label: 'CPF/CNPJ (busca cadastro existente)', type: 'cpf' },
    { key: 'nome', label: 'Nome' },
    { key: 'email', label: 'Email' }, { key: 'telefone', label: 'Telefone' },
    { key: 'whatsapp', label: 'WhatsApp' }, { key: 'data_nascimento', label: 'Data de nascimento', type: 'date' },
    { key: 'cep', label: 'CEP (preenche o endereço)', type: 'cep' },
    { key: 'endereco', label: 'Endereço (logradouro)' }, { key: 'numero', label: 'Número' },
    { key: 'complemento', label: 'Complemento' }, { key: 'bairro', label: 'Bairro' },
    { key: 'cidade', label: 'Cidade' }, { key: 'estado', label: 'UF' },
    { key: 'qualificacao_manual_id', label: 'Cargo (faixa) — atribuição manual do admin', type: 'select',
      optionsUrl: '/qualificacoes?limit=100', optionLabel: 'nome', optionValue: 'id',
      optionsEmpty: 'Automático (calculado pelas metas)' },
  ],
}

export const parceiros = {
  title: 'Parceiros / Fornecedores', endpoint: '/parceiros',
  columns: [
    { key: 'nome', label: 'Parceiro' }, { key: 'tipo_servico', label: 'Tipo de serviço' },
    { key: 'codigo', label: 'Código' },
    { key: 'sync_ativo', label: 'Sync API', render: (r) => bool(r.sync_ativo) },
    { key: 'ativo', label: 'Ativo', render: (r) => bool(r.ativo) },
  ],
  fields: [
    { key: 'nome', label: 'Nome do parceiro' },
    { key: 'tipo_servico', label: 'Tipo de serviço', type: 'select', options: [
      { value: 'energia_gd', label: 'Energia GD' }, { value: 'telecom', label: 'Telecom' },
      { value: 'protecao_veicular', label: 'Proteção Veicular' }, { value: 'internet', label: 'Internet' },
      { value: 'seguros', label: 'Seguros' }, { value: 'beneficios', label: 'Benefícios' },
    ] },
    { key: 'codigo', label: 'Código interno' },
    { key: 'api_url', label: 'API — URL (integração automática, opcional)' },
    { key: 'api_token', label: 'API — Token' },
    { key: 'sync_horario', label: 'Horário da sincronização (HH:MM)' },
    { key: 'sync_ativo', label: 'Sincronização automática ativa', type: 'checkbox', default: false },
  ],
}

export const distribuidoras = {
  title: 'Distribuidoras', endpoint: '/distribuidoras',
  columns: [
    { key: 'nome', label: 'Nome' }, { key: 'sigla', label: 'Sigla' },
    { key: 'estado', label: 'UF' }, { key: 'percentual_desconto', label: 'Desconto', render: (r) => pct(r.percentual_desconto) },
    { key: 'ativo', label: 'Ativo', render: (r) => bool(r.ativo) },
  ],
  fields: [
    { key: 'nome', label: 'Nome' }, { key: 'sigla', label: 'Sigla' },
    { key: 'estado', label: 'UF' }, { key: 'percentual_desconto', label: 'Desconto médio %', type: 'number' },
    { key: 'tipo_fatura', label: 'Tipo de fatura' }, { key: 'consumo_minimo_kwh', label: 'Consumo mín. kWh', type: 'number' },
    // Energia Compartilhada — config comercial / SPREAD
    { key: 'desconto_maximo', label: 'Desconto MÁXIMO permitido (geradora) %', type: 'number' },
    { key: 'desconto_cliente', label: 'Desconto ofertado ao CLIENTE %', type: 'number' },
    { key: 'spread_plataforma', label: 'Spread → Plataforma %', type: 'number' },
    { key: 'spread_rede', label: 'Spread → Rede MMN %', type: 'number' },
    { key: 'spread_fundo', label: 'Spread → Fundo Corporativo %', type: 'number' },
    { key: 'spread_reserva', label: 'Spread → Reserva Operacional %', type: 'number' },
    // Regras de comissão por ETAPA
    { key: 'com_assinatura', label: 'Comissão na Assinatura (R$)', type: 'number' },
    { key: 'com_validacao', label: 'Comissão na Validação (R$)', type: 'number' },
    { key: 'com_injecao', label: 'Comissão na Injeção (R$)', type: 'number' },
    { key: 'com_primeira_fatura_pct', label: '1ª Fatura — % ', type: 'number' },
    { key: 'com_primeira_fatura_valor', label: '1ª Fatura — ou R$ fixo', type: 'number' },
    { key: 'com_recorrente_pct', label: 'Recorrente — % sobre faturamento', type: 'number' },
    { key: 'com_recorrente_valor', label: 'Recorrente — ou R$/cliente/mês', type: 'number' },
  ],
}

export const geradoras = {
  title: 'Geradoras Parceiras (Energia GD)', endpoint: '/geradoras',
  columns: [
    { key: 'nome', label: 'Geradora' }, { key: 'cnpj', label: 'CNPJ' },
    { key: 'contato_comercial', label: 'Contato' }, { key: 'status', label: 'Status' },
  ],
  fields: [
    { key: 'nome', label: 'Nome da geradora' }, { key: 'cnpj', label: 'CNPJ' },
    { key: 'contato_comercial', label: 'Contato comercial' },
    { key: 'email', label: 'E-mail' }, { key: 'telefone', label: 'Telefone' },
    { key: 'api_integracao', label: 'API de integração (URL/obs.)' },
    { key: 'status', label: 'Status', type: 'select', default: 'ativa', options: [
      { value: 'ativa', label: 'Ativa' }, { value: 'standby', label: 'Stand-by' }, { value: 'encerrada', label: 'Encerrada' },
    ] },
  ],
}

export const planos = {
  title: 'Planos de Adesão', endpoint: '/planos-adesao',
  columns: [
    { key: 'descricao', label: 'Descrição' },
    { key: 'valor', label: 'Valor', render: (r) => money(r.valor) },
    { key: 'ativo', label: 'Ativo', render: (r) => bool(r.ativo) },
  ],
  fields: [
    { key: 'descricao', label: 'Descrição' }, { key: 'valor', label: 'Valor', type: 'number' },
  ],
}

export const usuarios = {
  title: 'Usuários', endpoint: '/usuarios',
  columns: [
    { key: 'nome', label: 'Nome' }, { key: 'email', label: 'Email' },
    { key: 'perfil', label: 'Perfil' }, { key: 'ativo', label: 'Ativo', render: (r) => bool(r.ativo) },
  ],
  fields: [
    { key: 'nome', label: 'Nome' }, { key: 'email', label: 'Email' },
    { key: 'perfil', label: 'Perfil', type: 'select', options: ['admin', 'licenciado', 'cliente'] },
    { key: 'senha', label: 'Senha (ao criar)', type: 'password' },
  ],
}

export const meiosPagamento = {
  title: 'Meios de Pagamento', endpoint: '/meios-pagamento',
  columns: [
    { key: 'nome', label: 'Nome' }, { key: 'tipo', label: 'Tipo' },
    { key: 'provedor', label: 'Provedor' }, { key: 'ativo', label: 'Ativo', render: (r) => bool(r.ativo) },
  ],
  fields: [
    { key: 'nome', label: 'Nome' },
    { key: 'tipo', label: 'Tipo', type: 'select', options: ['pix', 'cartao', 'boleto', 'gateway'] },
    { key: 'provedor', label: 'Provedor (asaas, pagarme...)' },
  ],
}

export const qualificacoes = {
  title: 'Plano de Carreira · Faixas (Reconhecimento)', endpoint: '/qualificacoes', searchable: false,
  // Reconhecimento (Módulo 1). As REGRAS FINANCEIRAS oficiais ficam em "Motor de Remuneração";
  // os % por faixa abaixo são LEGADO/fallback (usados quando o serviço herda a faixa).
  columns: [
    { key: 'ordem', label: '#' }, { key: 'nome', label: 'Faixa' },
    { key: 'meta_pv', label: 'Meta PV' },
    { key: 'status_permanente', label: 'Permanente', render: (r) => bool(r.status_permanente) },
    { key: 'min_conexoes_diretas_ativas', label: 'Clientes dir.' },
    { key: 'min_licenciados_diretos', label: 'Lic. dir.' },
    { key: 'vme_percentual', label: 'VME', render: (r) => pct(r.vme_percentual) },
    { key: 'comissao_direta_pct', label: 'Direta (leg.)', render: (r) => pct(r.comissao_direta_pct) },
  ],
  fields: [
    { key: 'nome', label: 'Nome da faixa' }, { key: 'ordem', label: 'Ordem', type: 'number' },
    { key: 'icone', label: 'Ícone (nome/SVG)' },
    { key: 'cor', label: 'Cor (hex)' },
    { key: 'status_permanente', label: 'Status permanente (reconhecimento nunca perdido)', type: 'checkbox' },
    // Metas de reconhecimento
    { key: 'meta_pv', label: 'Meta de PV / Volume Total', type: 'number' },
    { key: 'min_pv_pessoal', label: 'PV pessoal mín. (ativação)', type: 'number' },
    { key: 'min_conexoes_diretas_ativas', label: 'Clientes diretos mín.', type: 'number' },
    { key: 'min_licenciados_diretos', label: 'Licenciados diretos mín.', type: 'number' },
    { key: 'min_equipe', label: 'Equipe mínima (rede)', type: 'number' },
    { key: 'min_ativ5', label: 'Ativ5 mín.', type: 'number' },
    { key: 'min_recorrencia', label: 'Recorrência ativa mín.', type: 'number' },
    { key: 'min_producao', label: 'Produção mínima (PV/período)', type: 'number' },
    { key: 'vme_percentual', label: 'VME % (cap por linha)', type: 'number' },
    { key: 'tempo_min_qualificacao_dias', label: 'Tempo mín. de qualificação (dias)', type: 'number' },
    { key: 'tempo_requalificacao_dias', label: 'Tempo de requalificação (dias)', type: 'number' },
    // Reconhecimento — listas (JSONB)
    { key: 'beneficios', label: 'Benefícios da faixa', type: 'itens', addLabel: 'Adicionar benefício', subcampos: [
      { key: 'tipo', label: 'Tipo', placeholder: 'viagem, carro, bônus...' },
      { key: 'descricao', label: 'Descrição', type: 'textarea' },
    ] },
    { key: 'premiacoes', label: 'Premiações da faixa', type: 'itens', addLabel: 'Adicionar premiação', subcampos: [
      { key: 'nome', label: 'Nome' },
      { key: 'criterio', label: 'Critério' },
      { key: 'valor', label: 'Valor (R$)', type: 'number' },
      { key: 'imagem', label: 'Imagem (URL)' },
      { key: 'descricao', label: 'Descrição', type: 'textarea' },
    ] },
    // Financeiro por faixa — LEGADO/fallback (a regra oficial fica no Motor de Remuneração)
    { key: 'comissao_direta_pct', label: 'Comissão direta % (legado/fallback)', type: 'number' },
    { key: 'comissao_indireta_pct', label: 'Comissão indireta % (legado)', type: 'number' },
    { key: 'niveis_indireta', label: 'Níveis da indireta (legado)', type: 'number' },
    { key: 'ro_direta_pct', label: 'RO direta % (legado)', type: 'number' },
    { key: 'ro_indireta_pct', label: 'RO indireta % (legado)', type: 'number' },
    { key: 'niveis_ro', label: 'Níveis da RO (legado)', type: 'number' },
  ],
}

export const kits = {
  title: 'Kits de Recrutamento', endpoint: '/kits',
  columns: [
    { key: 'nome', label: 'Kit' },
    { key: 'valor', label: 'Valor', render: (r) => money(r.valor) },
    { key: 'pv', label: 'PV' },
    { key: 'bonus_direto', label: 'Bônus direto', render: (r) => money(r.bonus_direto) },
    { key: 'bonus_indireto', label: 'Bônus indireto', render: (r) => money(r.bonus_indireto) },
    { key: 'profundidade', label: 'Profundidade' },
    { key: 'ativo', label: 'Ativo', render: (r) => bool(r.ativo) },
  ],
  fields: [
    { key: 'nome', label: 'Nome do kit' }, { key: 'descricao', label: 'Descrição', type: 'textarea' },
    { key: 'valor', label: 'Valor (R$)', type: 'number' }, { key: 'pv', label: 'PV concedido', type: 'number' },
    { key: 'bonus_direto', label: 'Bônus direto (R$)', type: 'number' },
    { key: 'bonus_indireto', label: 'Bônus indireto (R$)', type: 'number' },
    { key: 'profundidade', label: 'Profundidade (níveis)', type: 'number' },
  ],
}

export const campanhas = {
  title: 'Premiações & Campanhas', endpoint: '/campanhas',
  columns: [
    { key: 'nome', label: 'Nome' },
    { key: 'tipo', label: 'Tipo' }, { key: 'premio', label: 'Prêmio' },
    { key: 'meta_descricao', label: 'Meta' },
    { key: 'data_fim', label: 'Até' },
    { key: 'ativo', label: 'Ativo', render: (r) => bool(r.ativo) },
  ],
  fields: [
    { key: 'nome', label: 'Nome' },
    { key: 'tipo', label: 'Tipo', type: 'select', options: ['campanha', 'premiacao'], default: 'campanha' },
    { key: 'premio', label: 'Prêmio (ex.: Cruzeiro, Carro 0km)' },
    { key: 'meta_descricao', label: 'Meta (ex.: 5 clientes do serviço X)' },
    { key: 'descricao', label: 'Descrição', type: 'textarea' },
    { key: 'data_inicio', label: 'Início', type: 'date' },
    { key: 'data_fim', label: 'Fim', type: 'date' },
  ],
}

export const simulacoes = {
  title: 'Minhas Simulações', endpoint: '/simulacoes', readOnly: true,
  columns: [
    { key: 'nome', label: 'Cliente' }, { key: 'whatsapp', label: 'WhatsApp', type: 'whatsapp' },
    { key: 'cidade', label: 'Cidade' }, { key: 'estado', label: 'UF' },
    { key: 'economia_mensal', label: 'Economia/mês', render: (r) => money(r.economia_mensal) },
    { key: 'status', label: 'Status' },
    { key: 'created_at', label: 'Data', render: (r) => r.created_at ? new Date(r.created_at).toLocaleDateString('pt-BR') : '—' },
  ],
}

export const notificacoes = {
  title: 'Notificações', endpoint: '/notificacoes', readOnly: true, searchable: false,
  columns: [
    { key: 'titulo', label: 'Título' }, { key: 'tipo', label: 'Tipo' },
    { key: 'mensagem', label: 'Mensagem' }, { key: 'lida', label: 'Lida', render: (r) => bool(r.lida) },
  ],
}

export const ofertas = {
  title: 'Catálogo · Ofertas (Serviços/Produtos)', endpoint: '/ofertas',
  columns: [
    { key: 'imagem_url', label: '', type: 'imagem' },
    { key: 'nome', label: 'Nome' }, { key: 'tipo', label: 'Tipo' },
    { key: 'categoria', label: 'Categoria' }, { key: 'pv', label: 'PV' },
    { key: 'preco', label: 'Preço', render: (r) => money(r.preco) },
    { key: 'ativo', label: 'Ativo', render: (r) => bool(r.ativo) },
  ],
  fields: [
    { key: 'tipo', label: 'Tipo', type: 'select', options: ['servico', 'produto'], default: 'servico' },
    { key: 'categoria', label: 'Categoria (energia, protecao_veicular, produto...)' },
    { key: 'nome', label: 'Nome' },
    { key: 'descricao', label: 'Descrição', type: 'textarea' },
    { key: 'pv', label: 'PV fixo (quando regra = Fixo)', type: 'number' },
    { key: 'preco', label: 'Preço', type: 'number' },
    { key: 'pv_regra', label: 'Regra de PV', type: 'select', default: 'fixa', options: [
      { value: 'fixa', label: 'Fixo (usa o campo PV)' }, { value: 'valor', label: '= Valor da fatura' },
      { value: 'valor_mult', label: 'Valor × multiplicador' }, { value: 'kwh_fator', label: 'Energia GD: kWh × fator' },
      { value: 'economia_pct', label: 'Energia GD: economia × %' },
    ] },
    { key: 'pv_fator', label: 'Fator (PV = kWh × fator)', type: 'number' },
    { key: 'pv_multiplicador', label: 'Multiplicador (PV = valor ×)', type: 'number' },
    { key: 'pv_percentual', label: '% sobre a economia', type: 'number' },
    { key: 'parceiro_id', label: 'Parceiro/Fornecedor', type: 'select', optionsUrl: '/parceiros?limit=200', optionLabel: 'nome', optionValue: 'id', optionsEmpty: '— nenhum —' },
    { key: 'usa_integracao_parceiro', label: 'Usar integração do parceiro (em vez de formulário próprio)', type: 'checkbox', default: false },
    { key: 'recorrente', label: 'Recorrente (assinatura)', type: 'checkbox', default: false },
    { key: 'estoque', label: 'Estoque (produto físico)', type: 'number' },
    { key: 'imagem_url', label: 'Imagem', type: 'imagem' },
    { key: 'escopo', label: 'Disponibilidade', type: 'select', options: ['global', 'licenciados'], default: 'global' },
    { key: 'campos_schema', label: 'Formulário do produto (campos parametrizáveis + uploads)', type: 'campos', default: [] },
  ],
}

// Produtos físicos = ofertas com tipo=produto (filtro fixo).
export const produtos = {
  title: 'Produtos', endpoint: '/ofertas', fixedParams: { tipo: 'produto' },
  columns: [
    { key: 'imagem_url', label: '', type: 'imagem' },
    { key: 'nome', label: 'Nome' }, { key: 'categoria', label: 'Categoria' },
    { key: 'sku', label: 'SKU' }, { key: 'pv', label: 'PV' },
    { key: 'preco', label: 'Preço', render: (r) => money(r.preco) },
    { key: 'estoque', label: 'Estoque', render: (r) => (r.estoque == null ? '∞' : r.estoque) },
    { key: 'ativo', label: 'Ativo', render: (r) => bool(r.ativo) },
  ],
  fields: [
    { key: 'categoria', label: 'Categoria' },
    { key: 'nome', label: 'Nome do produto' },
    { key: 'descricao', label: 'Descrição', type: 'textarea' },
    { key: 'sku', label: 'SKU / Código' },
    { key: 'pv', label: 'PV fixo (quando regra = Fixo)', type: 'number' },
    { key: 'preco', label: 'Preço', type: 'number' },
    { key: 'pv_regra', label: 'Regra de PV', type: 'select', default: 'fixa', options: [
      { value: 'fixa', label: 'Fixo (usa o campo PV)' }, { value: 'valor', label: '= Valor da venda' },
      { value: 'valor_mult', label: 'Valor × multiplicador' },
    ] },
    { key: 'pv_multiplicador', label: 'Multiplicador (PV = valor ×)', type: 'number' },
    { key: 'parceiro_id', label: 'Parceiro/Fornecedor', type: 'select', optionsUrl: '/parceiros?limit=200', optionLabel: 'nome', optionValue: 'id', optionsEmpty: '— nenhum —' },
    { key: 'usa_integracao_parceiro', label: 'Usar integração do parceiro (em vez de formulário próprio)', type: 'checkbox', default: false },
    { key: 'percentual_comissao', label: 'Comissão % (vazio = padrão)', type: 'number' },
    { key: 'estoque', label: 'Estoque (vazio = ilimitado)', type: 'number' },
    { key: 'imagem_url', label: 'Imagem', type: 'imagem' },
    { key: 'escopo', label: 'Disponibilidade', type: 'select', options: ['global', 'licenciados'], default: 'global' },
    { key: 'campos_schema', label: 'Formulário do produto (campos parametrizáveis + uploads)', type: 'campos', default: [] },
  ],
}

// Serviços = ofertas com tipo=servico (filtro fixo).
export const servicos = {
  title: 'Serviços', endpoint: '/ofertas', fixedParams: { tipo: 'servico' },
  columns: [
    { key: 'imagem_url', label: '', type: 'imagem' },
    { key: 'nome', label: 'Nome' }, { key: 'categoria', label: 'Categoria' },
    { key: 'pv', label: 'PV' },
    { key: 'preco', label: 'Preço', render: (r) => money(r.preco) },
    { key: 'recorrente', label: 'Recorrente', render: (r) => bool(r.recorrente) },
    { key: 'ativo', label: 'Ativo', render: (r) => bool(r.ativo) },
  ],
  fields: [
    { key: 'categoria', label: 'Categoria (energia, proteção, telefonia...)' },
    { key: 'nome', label: 'Nome do serviço' },
    { key: 'descricao', label: 'Descrição', type: 'textarea' },
    { key: 'pv', label: 'PV fixo (quando regra = Fixo)', type: 'number' },
    { key: 'preco', label: 'Preço', type: 'number' },
    { key: 'pv_regra', label: 'Regra de PV', type: 'select', default: 'fixa', options: [
      { value: 'fixa', label: 'Fixo (usa o campo PV)' }, { value: 'valor', label: '= Valor da fatura' },
      { value: 'valor_mult', label: 'Valor × multiplicador' }, { value: 'kwh_fator', label: 'Energia GD: kWh × fator' },
      { value: 'economia_pct', label: 'Energia GD: economia × %' },
    ] },
    { key: 'pv_fator', label: 'Fator (PV = kWh × fator)', type: 'number' },
    { key: 'pv_multiplicador', label: 'Multiplicador (PV = valor ×)', type: 'number' },
    { key: 'pv_percentual', label: '% sobre a economia', type: 'number' },
    { key: 'parceiro_id', label: 'Parceiro/Fornecedor', type: 'select', optionsUrl: '/parceiros?limit=200', optionLabel: 'nome', optionValue: 'id', optionsEmpty: '— nenhum —' },
    { key: 'usa_integracao_parceiro', label: 'Usar integração do parceiro (em vez de formulário próprio)', type: 'checkbox', default: false },
    { key: 'percentual_comissao', label: 'Comissão % (vazio = padrão)', type: 'number' },
    { key: 'recorrente', label: 'Recorrente (assinatura)', type: 'checkbox', default: true },
    { key: 'imagem_url', label: 'Imagem', type: 'imagem' },
    { key: 'escopo', label: 'Disponibilidade', type: 'select', options: ['global', 'licenciados'], default: 'global' },
    { key: 'campos_schema', label: 'Formulário do produto (campos parametrizáveis + uploads)', type: 'campos', default: [] },
  ],
}
